import Tippy from '@tippyjs/react'
import React from 'react'
import { IoCloseSharp } from 'react-icons/io5'
import styled from 'styled-components'
import { Scalars } from 'types/graphql'
import { useToggleBrandInList } from 'modules/member/lists/queries/useToggleBrandInList'

const Button = styled.button`
  appearance: none;
  background: none;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;

  path {
    color: var(--black-40);

    &:hover {
      color: var(--black-100);
    }
  }
`

interface Props {
  brandId: Scalars['ID']
  onClick?: () => void
}

export const DismissBrand = ({ brandId, onClick }: Props) => {
  const { toggleBrandInList } = useToggleBrandInList()

  const handleClick = async () => {
    toggleBrandInList({ brandId, listType: 'Dismissed' })()
    window.analytics.track('Brand Dismissed', {
      brandId
    })
    onClick?.()
  }

  return (
    <Tippy content="Hide this brand from my suggestions">
      <Button onClick={handleClick}>
        <IoCloseSharp size={20} />
      </Button>
    </Tippy>
  )
}
